export const shouldShowXMSurvey = (index, flightsLength, minResultsForStandardPosition) => {
    if (flightsLength === 0) {
        return false;
    }
    const standardPositionIndex = minResultsForStandardPosition - 1;
    if (flightsLength < minResultsForStandardPosition) {
        return index === flightsLength - 1;
    }
    return index === standardPositionIndex;
};
